import type { FigmaRestApi, ZeytalTokens } from "@zeytal/types";

import { findStyleValueKey } from "../../utils/figma-data.ts";

export const getColorStyleValue = (mappedStyle: ZeytalTokens.MappedStyle) => {
  const { node } = mappedStyle;

  const styleValueKey = findStyleValueKey(mappedStyle);

  if (!styleValueKey) {
    return [];
  }

  return node[styleValueKey] as FigmaRestApi.Paint[];
};
